import styled from "styled-components";
import RedactFlow from "./redact-services-chart.svg";
import Image from "next/image";

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 4rem 2rem 2rem 2rem;
  position: relative;
  margin-top: 4rem;
  z-index: 2;
  margin-bottom: 2rem;
  @media screen and (max-width: 992px) {
    padding: 1rem 2rem;
    margin-top: 0;
  }
  @media screen and (max-width: 768px) {
    padding: 0 2rem;
    margin-top: 2rem;
    margin-bottom: 0;
  }
`;
const StyledContainer = styled.div`
  max-width: 1280px;
  width: 100%;
  display: flex;
  align-items: center;
  h2 {
    font-size: 3rem;
    line-height: 4.2rem;
    font-weight: 700;
    margin: 0 0 2rem 0;
    @media screen and (max-width: 992px) {
      line-height: 2.8rem;
      font-size: 2rem;
    }
  }
  p {
    font-size: 1.2rem;
    line-height: 2rem;
  }
  @media screen and (max-width: 992px) {
    flex-direction: column;
  }
  > div {
    flex: 1 1 50%;
    padding: 0 1rem;
    @media screen and (max-width: 768px) {
      padding: 0 0;
    }
  }
`;
const StyledRight = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  svg {
    width: 100%;
  }
`;

const SectionOne = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <div>
          <h2>Manage social media deletions in one place</h2>
          <p>
            Cleaning up your social networks can be a hassle. Redact makes it easy to cleanup,
            delete and refresh your social networks in one place.
          </p>
        </div>
        <StyledRight>
          <Image className="mb-4 h-auto w-full sm:mb-0" src={RedactFlow} alt="flow chart" />
        </StyledRight>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default SectionOne;
